var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppLayout',{staticClass:"page-layout page-layout--empty"},[_c('div',{staticClass:"page-layout__content"},[_c('Nuxt',{attrs:{"nuxt-child-key":_vm.keepAliveKey}})],1),_vm._v(" "),_c('AppOfflineBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }